module.exports = __webpack_public_path__ + "static/media/Accessories.b0b76c6e.png";